import { WsEvent } from '@shared/api'
import { useSubscriptionStore } from '@entities/subscription'
import { onDisciplineReady } from '@entities/customer'
import { safeLocalStorage } from '@shared/lib/browser'
import { useCustomerStore } from '@entities/customer'
import { providerEventProps } from '@shared/lib/amplitude'
import { trackEvent } from '@shared/lib/amplitude'

export const useListenEventRetryPayment = (channel: any): void => {
  const subscriptionStore = useSubscriptionStore()
  const customerStore = useCustomerStore()

  // The charge of a retried subscription settles here, not in the retry request (spec rule 10).
  const trackRetryOutcome = (event: 'Payment_success' | 'Payment_error', subscriptionId: number | null): void => {
    trackEvent(event, {
      ...providerEventProps(customerStore.getPaymentProvider),
      feature: 'subscription',
      name: 'retry_payment',
      subscription_id: subscriptionId,
    })
  }

  onDisciplineReady(() => {

    channel.listen(WsEvent.SubscriptionRetryFailed, async (event: any): Promise<void> => {
      const subscriptionId = subscriptionStore.getPaymentRetrySubscriptionId

      if (subscriptionId === event.subscription_id) {
        trackRetryOutcome('Payment_error', subscriptionId)

        subscriptionStore.setBannerPaymentRetryProcessing(false)
        subscriptionStore.setModalRetryPaymentProcessing(false)

        subscriptionStore.setModalPaymentRetrySuccess(false)

        subscriptionStore.setRetryPaymentModal(true)
        subscriptionStore.setBannerPaymentRetry(true)
      }
    })

    channel.listen(WsEvent.SubscriptionRetrySuccessful, async (event: any): Promise<void> => {
      const subscriptionId = subscriptionStore.getPaymentRetrySubscriptionId

      if (subscriptionId === event.subscription_id) {
        trackRetryOutcome('Payment_success', subscriptionId)

        subscriptionStore.setBannerPaymentRetryProcessing(false)
        subscriptionStore.setModalRetryPaymentProcessing(false)

        subscriptionStore.setRetryPaymentModal(false)
        subscriptionStore.setBannerPaymentRetry(false)

        subscriptionStore.setModalPaymentRetrySuccess(true)

        subscriptionStore.setPaymentRetryData(null)
        safeLocalStorage.removeItem('bannerPaymentRetryProcessing')
      }
    })
  })
}
